import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { IonCol, IonRow } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-row-with-fixed-col-title',
    imports: [CommonModule, IonRow, IonCol],
    templateUrl: './row-with-fixed-col-title.component.html',
    styleUrl: './row-with-fixed-col-title.component.css'
})
export class RowWithFixedColTitleComponent {
    @Input() title: string = '';
    @Input() separator: string = ':';
    @Input() fixedColSize: string = '3';
    @Input() useDefaultStyling: boolean = true;
    @Input() class: string = '';
}
